import styled from '@emotion/styled';
import type {
  FunnelQuery,
  AdditionalTrackingData,
  FilterChainSeries,
} from '@hotjar/dashboard-quantz';
import { tokens, Text } from '@hotjar/hotsauce';
import type { PlanComparisonReferrer } from '@hotjar/webapp/features/Billing/PlanComparisonModal/types';
import { useTranslation } from '@hotjar/translations';
import type { ContextOfUse, DateRange } from '@hotjar/global-filters';
import { MultiFilterChain } from './MultiFilterChain/MultiFilterChain';

const WrapperDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tokens.spacer.x2};
`;

interface GlobalFilterSectionPros {
  currentFunnelQuery: FunnelQuery;
  setCurrentFunnelQuery: (newFunnelQuery: FunnelQuery) => void;
  onUpsellRequest: (
    featureName: PlanComparisonReferrer,
    additionalTrackingData?: AdditionalTrackingData,
  ) => void;
  trackClick: (
    eventName: string,
    additionalTrackingData: {
      // eslint-disable-next-line camelcase
      ui_position: string;
    },
  ) => void;
  contextOfUse: ContextOfUse;
}

export const GlobalFilterSection = ({
  currentFunnelQuery,
  setCurrentFunnelQuery,
  onUpsellRequest,
  trackClick,
  contextOfUse,
}: GlobalFilterSectionPros): JSX.Element => {
  const { t } = useTranslation('funnels');

  return (
    <WrapperDiv>
      <Text textType="subtitle2">{t('globalFilterSection.filterBy')}</Text>
      <MultiFilterChain
        filterChainSeriesList={currentFunnelQuery.filterChainSeries}
        dateRange={currentFunnelQuery.dateRange}
        onFilterChainSeriesUpdate={(
          newFilterChainSeriesList: FilterChainSeries[],
          newDateRange?: DateRange,
        ) => {
          setCurrentFunnelQuery({
            ...currentFunnelQuery,
            filterChainSeries: newFilterChainSeriesList,
            dateRange: newDateRange ?? currentFunnelQuery.dateRange,
          });
        }}
        onUpsellRequest={onUpsellRequest}
        trackClick={trackClick}
        hideHeaderLabel
        contextOfUse={contextOfUse}
      />
    </WrapperDiv>
  );
};
